import PageWithHeader from '../../components/PageWithHeader/PageWithHeader';
import styles from './GetApp.module.css';

const GetApp = () => {
  return (
    <PageWithHeader>
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <div className={styles.leftContent}>
            <div className={styles.title}>
              Time to track your plan
            </div>
            <div className={styles.subTitle}>
              Your personal AI nutritionist, at your fingertips.
            </div>
            <a 
              className={styles.downloadLink} 
              href="https://apps.apple.com/gb/app/mealwell-diet-food-planner/id6743499265" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              Download for free
            </a>
          </div>
        </div>
        
      </div>
    </PageWithHeader>
  );
};

export default GetApp;